import PropTypes from 'prop-types';
import {Component} from 'react';
import {connect} from 'react-redux';
import ChineseResidentIDHelper from '../../helpers/ChineseResidentIDHelper';
import DetailedTooltip from '../DetailedTooltip';

export class ChineseResidentIDTooltip extends Component {
  render() {
    return (
      <DetailedTooltip title={this.props.translations['deliveryOptions.resident.id.chinese.title']} tooltipID={this.props.tooltipID}>
        <ChineseResidentIDHelper />
      </DetailedTooltip>
    );
  }
}

ChineseResidentIDTooltip.propTypes = {
  translations: PropTypes.object.isRequired,
  tooltipID: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  translations: state.lang,
});

export default connect(mapStateToProps)(ChineseResidentIDTooltip);
